import { IHttpApi } from '@cian/http-api/shared';
import { ILogger } from '@cian/logger';
import { HttpTimeoutError } from '@cian/peperrors/shared';
import {
  fetchGetRegions,
  IGetRegionsResponse,
  IGetRegionsResponse400,
} from '../repositories/monolith-python/v1/get-regions';
import { IGetRegionsResponse200 } from '../repositories/monolith-python/v1/get-regions/types';
import { getRegionsApiCache, GET_REGIONS_API_CACHE_KEY } from './getRegionsApiCache';

export async function getRegions(httpApi: IHttpApi, logger: ILogger, timeout?: number) {
  const cacheData = getRegionsApiCache.getData<IGetRegionsResponse>(GET_REGIONS_API_CACHE_KEY);
  if (cacheData) {
    return cacheData;
  }

  try {
    const result = await fetchGetRegions<IGetRegionsResponse200, IGetRegionsResponse400>({
      httpApi,
      parameters: {},
      config: {
        ecnhancersConfig: { timeout },
      },
    });

    if (result.statusCode !== 200) {
      throw result.response;
    }

    getRegionsApiCache.setData(GET_REGIONS_API_CACHE_KEY, result.response);

    return result.response;
  } catch (error) {
    const message = error instanceof HttpTimeoutError ? 'TimeoutError in getRegions' : 'Error in getRegions';

    logger.error(error, { message });

    return { data: { items: [] } };
  }
}
